import { useAuth } from "@/src/contexts/auth.context";
import { PostComment, ReactionType } from "@/src/models/post.model";
import {
    useGetUserCommentReaction,
    useReactToCommentMutation,
} from "@/src/services/api/posts/posts.hooks";

export const useReactToComment = (comment: PostComment) => {
  const { user } = useAuth();
  const userId = user?.userID ?? "";

  const { data: userReaction } = useGetUserCommentReaction(
    comment.ItemId,
    userId,
  );
  const { mutate } = useReactToCommentMutation();

  const handleReact = (newReaction: ReactionType | null) => {
    mutate({
      commentId: comment.ItemId,
      postId: comment.postId,
      userId,
      newReaction,
      previousReaction: userReaction?.type ?? null,
      currentCounts: comment.reactionCount,
      existingReactionId: userReaction?.id,
    });
  };

  return { userReaction, handleReact };
};
